__turbopack_context__.v({
  "Form": "Newsletter-module-scss-module__WEXLtG__Form",
  "Input": "Newsletter-module-scss-module__WEXLtG__Input",
  "InputGroup": "Newsletter-module-scss-module__WEXLtG__InputGroup",
  "Label": "Newsletter-module-scss-module__WEXLtG__Label",
  "Newsletter": "Newsletter-module-scss-module__WEXLtG__Newsletter",
  "Submit": "Newsletter-module-scss-module__WEXLtG__Submit",
});
